// type of arrayRow is an array of numbers

export let CustomGridScrollDirection = /*#__PURE__*/function (CustomGridScrollDirection) {
  CustomGridScrollDirection["vertical"] = "vertical";
  CustomGridScrollDirection["horizontal"] = "horizontal";
  return CustomGridScrollDirection;
}({});
//# sourceMappingURL=customGridTypes.js.map